var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 91.33v277c0 11.31-7.1 21.88-18.5 26.47C317.7 465 281.7 331.25 96 416V102a56.57 56.57 0 0 0 14.64-15c194.19-74.48 184.75 58.25 352-20.08C485.2 56.31 512 68.26 512 91.33z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M120 56a55.93 55.93 0 0 1-24 46v388a22 22 0 0 1-22 22H54a22 22 0 0 1-22-22V102a56 56 0 1 1 88-46z","className":"fa-primary","key":2})]);
}

Flag.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Flag;

Flag.default = Flag;
